import { apiClient } from "@/api/api-client";
import { ApiResponse } from "@/types/api-response";
import {
  MessageTemplate,
  MessageTemplateCreateRequest,
  MessageTemplateUpdateRequest,
} from "@/types/message-template-type";
import { endpoints } from "./endpoints/endpoints";

export async function getMessageTemplate(
  id: string
): Promise<ApiResponse<MessageTemplate>> {
  try {
    const response = await apiClient.get<MessageTemplate, void>(
      endpoints.messageTemplate.get(id)
    );
    return response as ApiResponse<MessageTemplate>;
  } catch (error) {
    console.error("Error getting message template:", error);
    throw error;
  }
}

export async function createMessageTemplate(
  request: MessageTemplateCreateRequest
): Promise<ApiResponse<any>> {
  try {
    const response = await apiClient.post(
      endpoints.messageTemplate.create,
      request
    );
    console.log("Message template created:", response.data);
    return response.data as ApiResponse<any>;
  } catch (error) {
    console.error("Error creating message template:", error);
    throw error;
  }
}

export async function updateMessageTemplate(
  id: string,
  request: MessageTemplateUpdateRequest
): Promise<ApiResponse<any>> {
  try {
    const response = await apiClient.put(
      endpoints.messageTemplate.update(id),
      request
    );
    console.log("Message template updated:", response.data);
    return response.data as ApiResponse<any>;
  } catch (error) {
    console.error("Error updating message template:", error);
    throw error;
  }
}

export async function deleteMessageTemplate(
  id: string
): Promise<ApiResponse<MessageTemplate>> {
  try {
    const response = await apiClient.delete<MessageTemplate>(
      endpoints.messageTemplate.delete(id)
    );
    return response;
  } catch (error) {
    console.error("Error deleting message template:", error);
    throw error;
  }
}
